import React, { FC, Suspense } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { RouterProps } from 'router/routeUrl';
import Loading from 'components/Loading';
import BaseLayout from 'components/BaseLayout';
import Error404 from '../Error404/index';

// const defaultRedirect = `${baseUrl}/home`;

interface BaseRouteProps {
  routeUrl: RouterProps[];
  routeUrlNoSider: RouterProps[];
  catchRouteUrl: RouterProps[];
}

const BaseRoute: FC<BaseRouteProps> = (props) => {
  return (
    <BaseLayout menu={props.routeUrlNoSider}>
      <Suspense fallback={<Loading />}>
        <Switch>
          {props.routeUrlNoSider.map((item) => {
            const { path, component } = item;
            return <Route key={path} exact path={path} component={component} />;
          })}
          <Redirect path="/" exact to="/home" />
          <Route path="*" component={Error404} />
        </Switch>
      </Suspense>
    </BaseLayout>
  );
};

export default withRouter(BaseRoute);
